var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Box, Button, Chip, ClickAwayListener, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Edit02Icon, Link05Icon, PuzzleIcon, Tick02Icon } from 'hugeicons-react';
import { useEffect, useState } from 'react';
import useTranslate from '../../../../../../localization/helpers';
import LinkMachineDialog from '../link-machine-dialog';
import { highlightMatch } from '../../../../../../application/utilities/highlightMatch';
var MatchingMachineDetail = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var machine = _a.machine, onLinkAndUnlink = _a.onLinkAndUnlink, machineData = _a.machineData, watch = _a.watch, setLinkedMatchingMachine = _a.setLinkedMatchingMachine, removeLinkedMatchingMachine = _a.removeLinkedMatchingMachine;
    var translate = useTranslate().translate;
    var theme = useTheme();
    var _j = __read(useState(false), 2), linkMachineModalOpen = _j[0], setLinkMachineModalOpen = _j[1];
    var currentMachineData = watch('machineData');
    var modelNumberToMatch = ((_b = machine.modelsWithDocuments[0]) === null || _b === void 0 ? void 0 : _b.modelNumber) || '';
    var _k = __read(useState(false), 2), openTooltip = _k[0], setOpenTooltip = _k[1];
    var isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    var handleClick = function () {
        if (isMobile) {
            setOpenTooltip(function (prev) { return !prev; });
        }
    };
    var handleClickAway = function () {
        if (isMobile && openTooltip) {
            setOpenTooltip(false);
        }
    };
    useEffect(function () {
        var handleScroll = function () {
            if (openTooltip) {
                setOpenTooltip(false);
            }
        };
        window.addEventListener('scroll', handleScroll, true);
        return function () {
            window.removeEventListener('scroll', handleScroll, true);
        };
    }, [openTooltip]);
    var matchedData = currentMachineData.find(function (data) {
        return modelNumberToMatch === null || modelNumberToMatch === void 0 ? void 0 : modelNumberToMatch.toLowerCase().includes(data.modelNumber.toLowerCase());
    });
    var searchModelNumberTerm = (matchedData === null || matchedData === void 0 ? void 0 : matchedData.modelNumber) || '';
    var shouldHighlight = searchModelNumberTerm &&
        modelNumberToMatch &&
        searchModelNumberTerm.toLowerCase() !== modelNumberToMatch.toLowerCase();
    var highlightedModelNumber = shouldHighlight
        ? highlightMatch({
            text: modelNumberToMatch,
            searchTerm: searchModelNumberTerm,
            theme: theme
        })
        : modelNumberToMatch;
    var onLink = function () {
        setLinkMachineModalOpen(true);
    };
    var isLinked = machineData.some(function (m) {
        return m.files.some(function (f) {
            return f.linkedDocumentId &&
                machine.modelsWithDocuments.some(function (model) {
                    return model.documents.some(function (doc) { return doc.documentId === f.linkedDocumentId; });
                });
        });
    });
    return (_jsxs(Box, { display: 'flex', flexDirection: 'column', gap: '4px', borderRadius: '12px', padding: '6px 12px', bgcolor: theme.palette.background.neutral, children: [_jsxs(Box, { display: 'flex', flexDirection: 'column', gap: 1, children: [((_c = machine.modelsWithDocuments[0]) === null || _c === void 0 ? void 0 : _c.modelNumber) && (_jsxs(Box, { display: 'flex', flexDirection: 'row', gap: 0.5, alignItems: 'center', children: [_jsxs(Typography, { variant: 'body2', color: theme.palette.text.secondary, children: [translate('assets.matchingAssets.model'), ":"] }), _jsx(Chip, { sx: {
                                    '& .MuiChip-label': {
                                        fontWeight: 600
                                    }
                                }, size: 'small', icon: ((_e = (_d = machine.modelsWithDocuments[0]) === null || _d === void 0 ? void 0 : _d.modelNumber) === null || _e === void 0 ? void 0 : _e.toLowerCase()) ===
                                    (searchModelNumberTerm === null || searchModelNumberTerm === void 0 ? void 0 : searchModelNumberTerm.toLowerCase()) ? (_jsx(PuzzleIcon, { width: 18, height: 18 })) : undefined, variant: ((_g = (_f = machine.modelsWithDocuments[0]) === null || _f === void 0 ? void 0 : _f.modelNumber) === null || _g === void 0 ? void 0 : _g.toLowerCase()) ===
                                    (searchModelNumberTerm === null || searchModelNumberTerm === void 0 ? void 0 : searchModelNumberTerm.toLowerCase())
                                    ? 'filled'
                                    : 'outlined', color: 'primary', label: highlightedModelNumber }), isLinked && (_jsx(Chip, { icon: _jsx(Tick02Icon, { size: 18 }), label: translate('assets.matchingAssets.linked'), color: 'primary', size: 'small', variant: 'filled', sx: { '& .MuiChip-label': { fontWeight: 600 } } }))] })), _jsxs(Box, { display: 'flex', flexDirection: 'row', gap: 0.5, alignItems: 'center', flexWrap: 'wrap', children: [_jsxs(Typography, { variant: 'caption', color: theme.palette.text.secondary, children: [translate('assets.matchingAssets.documents'), ":"] }), machine.modelsWithDocuments
                                .flatMap(function (model) { return model.documents; })
                                .filter(function (doc) { return doc.isMatching; }).length > 0 && (_jsx(Chip, { sx: {
                                    '& .MuiChip-label': {
                                        fontWeight: 600
                                    }
                                }, icon: _jsx(PuzzleIcon, { width: 18, height: 18 }), label: translate('assets.matchingAssets.match', {
                                    count: machine.modelsWithDocuments
                                        .flatMap(function (model) { return model.documents; })
                                        .filter(function (doc) { return doc.isMatching; }).length
                                }), color: 'primary', size: 'small', variant: 'filled' })), _jsx(Chip, { sx: {
                                    '& .MuiChip-label': {
                                        fontWeight: 600
                                    }
                                }, label: translate('assets.matchingAssets.total', {
                                    count: machine.modelsWithDocuments.flatMap(function (model) { return model.documents; }).length
                                }), color: 'primary', size: 'small', variant: 'outlined' }), machine.modelsWithDocuments.some(function (model) {
                                return model.documents.some(function (doc) { return doc.isLinked; });
                            }) && (_jsx(ClickAwayListener, { onClickAway: handleClickAway, children: _jsx(Box, { display: 'flex', alignItems: 'center', children: _jsx(Tooltip, { placement: 'top', arrow: true, title: translate('assets.linkedDocumentsTooltip'), open: isMobile ? openTooltip : undefined, disableHoverListener: isMobile, disableFocusListener: isMobile, disableTouchListener: isMobile, children: _jsx(Link05Icon, { onClick: handleClick, width: 24, height: 24 }) }) }) }))] }), _jsx(Box, { display: 'flex', flexDirection: 'row', children: _jsx(Typography, { variant: 'caption', color: theme.palette.text.secondary, children: translate('assets.matchingAssets.addedBy', {
                                company: machine.companyName,
                                date: new Date(machine.createdDate).toLocaleDateString(translate('common.dateLanguageCode1'), {
                                    year: 'numeric',
                                    month: 'short',
                                    day: 'numeric'
                                })
                            }) }) }), _jsx(Box, { display: 'flex', gap: 1, children: _jsx(Button, { size: 'small', fullWidth: true, variant: 'soft', color: 'primary', onClick: function () { return onLink(); }, startIcon: !isLinked ? _jsx(Link05Icon, {}) : _jsx(Edit02Icon, {}), children: !isLinked
                                ? translate('assets.linkToAsset')
                                : translate('assets.matchingAssets.editLinkedDocs') }) })] }), linkMachineModalOpen && machine && (_jsx(LinkMachineDialog, { isOpen: linkMachineModalOpen, onClose: function () { return setLinkMachineModalOpen(false); }, onLinkAndUnlink: onLinkAndUnlink, machine: machine, machineData: machineData, modelNumber: (_h = machine.modelsWithDocuments[0]) === null || _h === void 0 ? void 0 : _h.modelNumber, setLinkedMatchingMachine: function (machineId) { return setLinkedMatchingMachine(machineId); }, removeLinkedMatchingMachine: function (machineId, removeAll) {
                    return removeLinkedMatchingMachine(machineId, removeAll);
                } }))] }));
};
export default MatchingMachineDetail;
